import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.AgentPortal = function () {

};
HSN.Service.AgentPortal.prototype = {
    GetMain: function (config) {
        this._ajaxGet('/agent-portal/main', {}, config);
    },
    GetStatus: function (config) {
        this._send('/agent-portal/status', {}, config);
    },
    Authenticate: function (data, config) {
        this._send('/agent-portal/authenticate', data, config);
    },
    Signout: function (config) {
        this._send('/agent-portal/signout', {}, config);
    },
    Search: function (data, config) {
        this._send('/agent-portal/search', data, config);
    },
    SetState: function(data, config) {
        this._send('/agent-portal/set-state', data, config);
    },
    SelectCustomer: function(data, config) {
        this._send('/agent-portal/select-customer', data, config);
    },
    NewCustomer: function (config) {
        this._send('/agent-portal/new-customer', {}, config);
    },
    ClearCustomer: function(config) {
        this._send('/agent-portal/reset-session', {}, config);
    },
    ApplyCard: function (data, config) {
        this._send('/agent-portal/apply-card', data, config);
    },
    TogglePortal: function (data, config) {
        this._send('/portal-admin/toggle-portal', data, config);
    },

    _send: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'POST',
                data: data,
                context: this,
                dataType: 'json',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function () {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback));
                    }
                    else if (config.callback) {
                        config.callback.call((config.scope || config.callback), true);
                    }
                }
            }
        );
    },

    _ajaxGet: function (url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: config.dataType || 'html',
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, status) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), status);
                    }
                }
            }
        );
    },

    _get: function(url, data, config) {
        // ReSharper disable once AssignedValueIsNeverUsed
        config = (config = config || {});

        if (typeof data === 'string') {
            var joiner = data.indexOf("=") === -1 ? "" : "&";
            data += joiner + "_ts=" + new Date().getTime();
        } else {
            data['_ts'] = new Date().getTime();
        }

        $.ajax
        (
            url,
            {
                type: 'GET',
                data: data,
                context: this,
                dataType: 'json',
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-Requested-With', { toString: function () { return ''; } });
                },
                success: function (responseData) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), responseData);
                    }
                },
                error: function (xhr, status) {
                    if (config.errorCallback) {
                        config.errorCallback.call((config.scope || config.errorCallback), status);
                    }
                }
            }
        );
    }
};


// WEBPACK FOOTER //
// ./assets/js/HSN/Service/AgentPortal.js